import { createContext } from 'react';
import { IAuth } from 'common/types';

const AuthContext = createContext<IAuth>({} as IAuth);

export default AuthContext;
